import styled from '../../../../../../styles/styledComponents/themeComponents';

export const ColorInputFormStyle = styled.div`
  .amondz-form {
    &.with-label {
      align-items: center;
    }
    .ant-form-item-label {
      width: auto;
      margin-right: 5px;
      align-self: start;
    }

    .ant-form-item-children > div {
      display: flex;
      .preview {
        width: 32px;
        height: 32px;
        border: 1px solid #d9d9d9;
        border-right: 0;
      }
      .amondz-input {
        width: 160px;
      }
    }

    .ant-form-explain {
      white-space: pre;
    }
  }
`;

interface PreviewStyleProps {
  backgroundColor?: string;
}
export const PreviewStyle = styled.div<PreviewStyleProps>`
  width: 32px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-right: 0;
  background-color: ${(props) => props.backgroundColor};
`;
